import HTTP from "../services/httpServices";
import getURLDetails from "../services/endPoints";
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from "../utils/constants";

// Environments :-
// 1: prod -> Production Envirionment
// 2: uat -> User Acceptance Environment
// 3: unt -> User Acceptance Environment
// 4: dev -> Develpoment Environment
export enum Environments {
  prod,
  alpha,
  uat,
  unt,
  dev
}
type EnviName = keyof typeof Environments;

/**
 * To get configurable information for the specified Environment.
 * @param {string} enviName environment name.
 */
export default class Environment {
  environment: EnviName;

  constructor(enviName: EnviName) {
    this.environment = enviName;
  }

  /**
   * To fetch online Keys information for the specified environment.
   * * @returns {object} promise object with list of key-value pairs.
   */
  async __fetchOnlineConfig(
    subscriptionKey: string,
    token: string,
    endPoint: string
  ) {
    return new HTTP()
      .__requestRestApi(
        getURLDetails("CONFIG", "APP_LEVEL", "default").get_Service_Url(),
        {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: `Bearer ${token}`
        },
        "get"
      )
      .then((response: any) => response.data[0])
      .catch(async function(err: any) {
        const _http: any = new HTTP().__instance();
        return _http.get("./online-mock.json").then((response: any) => {
          return response.data[0];
        });
      });
  }
  /**
   * To fetch online Keys information for the specified environment.
   * * @returns {object} promise object with list of key-value pairs.
   */
  async __fetchOnlineSNIConfig(subscriptionKey: string, token: string) {
    return new HTTP()
      .__requestRestApi(
        getURLDetails(
          "EXPERIENCE",
          "CONTENTORCONFIG",
          "default"
        ).get_Service_Url(),
        {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: `Bearer ${token}`
        },
        "post",
        [
          {
            configTable: CONTENT_OR_CONFIG_TABLE_MAPPING.Global.tableName
          }
        ]
      )
      .then((response: any) => JSON.parse(response.data[0].config[0].output[0].value))
      .catch(async function(err: any) {
        const _http: any = new HTTP().__instance();
        return _http.get("./online-SNI-mock.json").then((response: any) => {
          return response.data;
        });
      });
  }

  /**
   * To get Headers information for the specified servcie API.
   * @param {*} wrapper common service to maintain keys.
   * @param {*} __wrteKeys to set key-values pairs in store.
   * @param {*} __readKeys to get key-values pairs from store
   * @returns {object} promise object.
   */
  async getConfig(
    wrapper: any,
    store: any,
    subscriptionKey: string,
    token: string,
    endPoint: string
  ): Promise<void> {
    if (!store) {
      throw new Error(
        "Store service is not provided to share Keys accross the Applciation"
      );
    }

    const storeKey = "config";
    const vault = await store.getVault();
    if (!(await vault.getValue(storeKey))) {
      try {
        const [onlineConfig, SNIConfig] = (await Promise.all([
          this.__fetchOnlineConfig(subscriptionKey, token, endPoint),
          this.__fetchOnlineSNIConfig(subscriptionKey, token)
        ])) as [any, any];
        const finalConfig = {
          ...onlineConfig,
          configuration: { ...onlineConfig.configuration,...SNIConfig }
        };
        if (Object.keys(finalConfig).length) {
          vault.storeValue(storeKey, btoa(JSON.stringify({ ...finalConfig })));
          wrapper.getKeys(JSON.parse(atob(await vault.getValue(storeKey))));
        }
      } catch (err) {
        // throw new Error(err);
        console.error("Error",err)
      }
    } else {
      wrapper.getKeys(JSON.parse(atob(await vault.getValue(storeKey))));
    }
  }
}
